var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"healthReport"},[_c('div',{staticClass:"healthReport-t"},_vm._l((_vm.titleList),function(item,index){return _c('div',{key:index,class:['item', { active: item.key == _vm.oKey }],on:{"click":function($event){return _vm.selectTitle(item)}}},[_vm._v(" "+_vm._s(item.value)+" ")])}),0),(_vm.oKey == _vm.heightWeight.examItemCode)?_c('div',{staticClass:"healthReport-c"},[_c('div',{staticClass:"title"},[_vm._v("身高体重检测")]),_c('div',{staticClass:"intro"},[_vm._v(" 身体质量指数（BMI）又称为体重指数、体质指数，该指标在一定程度可以反映人体密度， 用于评价人体的营养状况、胖瘦程度或身体发育水平。 ")]),_c('div',{staticClass:"heightWight thirdItem"},_vm._l((_vm.heightWeight.examResultList),function(item,index){return _c('div',{key:index,class:['item', { active: item.itemName == 'Bmi' }]},[_c('div',{staticClass:"item-t"},[_vm._v(_vm._s(_vm.hHDictionary[item.itemName].value))]),_c('div',{class:['item-b']},[_vm._v(" "+_vm._s(item.itemValue)+" ")])])}),0),_c('div',{staticClass:"title"},[_vm._v("BMI结果分布")]),_c('div',{staticClass:"BMI"},[(_vm.heightWeightData.Bmi)?_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.heightWeightData.Bmi.itemValue,
                  0,
                  18.5,
                  36,
                  0,
                  '最小'
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.heightWeightData.Bmi.itemValue,
                  0,
                  18.5,
                  36,
                  0,
                  164
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(" "+_vm._s(_vm.heightWeightData.Bmi.itemValue)+" ")])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("偏低")])]),_c('div',{staticClass:"item3 item"},[_c('div',{staticClass:"num"},[_vm._v("18.5")]),_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.heightWeightData.Bmi.itemValue,
                  18.5,
                  24.0,
                  36,
                  0
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.heightWeightData.Bmi.itemValue,
                  18.5,
                  24.0,
                  36,
                  0,
                  164
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(" "+_vm._s(_vm.heightWeightData.Bmi.itemValue)+" ")])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])]),_c('div',{staticClass:"item4 item"},[_c('div',{staticClass:"num"},[_vm._v("24.0")]),_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.heightWeightData.Bmi.itemValue,
                  24.0,
                  28.0,
                  36,
                  0
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.heightWeightData.Bmi.itemValue,
                  24.0,
                  28.0,
                  36,
                  0,
                  164
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(" "+_vm._s(_vm.heightWeightData.Bmi.itemValue)+" ")])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("超重")])]),_c('div',{staticClass:"item6 item"},[_c('div',{staticClass:"num"},[_vm._v("28.0")]),_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.heightWeightData.Bmi.itemValue,
                  28.0,
                  36,
                  36,
                  0,
                  '最大'
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.heightWeightData.Bmi.itemValue,
                  28.0,
                  36,
                  36,
                  0,
                  164
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(" "+_vm._s(_vm.heightWeightData.Bmi.itemValue)+" ")])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("肥胖")])])]):_vm._e()]),_c('div',{staticClass:"advise"},[_vm._v(_vm._s(_vm.heightWeightData.advise))])]):_vm._e(),(_vm.oKey == _vm.peopleComponent.examItemCode)?_c('div',{staticClass:"healthReport-c peopleComponent"},[_c('div',{staticClass:"peopleComponent-t"},[_c('div',{staticClass:"peopleComponent-tt"},[(_vm.peopleComponentData.Bmi)?_c('div',{staticClass:"peopleComponent-ttl"},[(_vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue) == 1)?_c('img',{staticClass:"fat1",attrs:{"src":require("./img/fat1.png"),"alt":""}}):_vm._e(),(_vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue) == 2)?_c('img',{staticClass:"fat2",attrs:{"src":require("./img/fat2.png"),"alt":""}}):_vm._e(),(_vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue) == 3)?_c('img',{staticClass:"fat3",attrs:{"src":require("./img/fat3.png"),"alt":""}}):_vm._e(),(_vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue) == 4)?_c('img',{staticClass:"fat4",attrs:{"src":require("./img/fat4.png"),"alt":""}}):_vm._e()]):_vm._e(),_c('div',{staticClass:"peopleComponent-ttr"},[(_vm.peopleComponentData.Weight)?_c('div',{staticClass:"peopleComponent-ttrl"},[_c('div',{staticClass:"peopleComponent-ttrlt"},[_vm._v(" "+_vm._s(_vm.peopleComponentData.Weight.createTime)+" ")]),_c('div',{staticClass:"peopleComponent-ttrlb"},[_vm._v(" "+_vm._s(_vm.peopleComponentData.Weight.itemValue)+" "),_c('span',[_vm._v(_vm._s(_vm.peopleComponentData.Weight.itemName && _vm.hHDictionary[_vm.peopleComponentData.Weight.itemName] ? _vm.hHDictionary[_vm.peopleComponentData.Weight.itemName].unit : ""))])])]):_vm._e(),(_vm.peopleComponentData.Bmi)?_c('div',{staticClass:"peopleComponent-ttrr"},[_c('div',{staticClass:"peopleComponent-ttrrt"},[_vm._v(" "+_vm._s(_vm.peopleComponentData.Bmi.itemName && _vm.hHDictionary[_vm.peopleComponentData.Bmi.itemName] ? _vm.hHDictionary[_vm.peopleComponentData.Bmi.itemName].value : "")+" ")]),_c('div',{staticClass:"peopleComponent-ttrrb"},[_vm._v(" "+_vm._s(_vm.peopleComponentData.Bmi ? _vm.peopleComponentData.Bmi.itemValue : "")+" ")]),(_vm.peopleComponentData.Bmi)?_c('div',{class:[
                'bmiData',
                'oActive',
                'oActive' + _vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue),
              ]},[_vm._v(" "+_vm._s(_vm.bmiArrMap[_vm.checkBmiLevel(_vm.peopleComponentData.Bmi.itemValue)])+" ")]):_vm._e()]):_vm._e()])]),_c('div',{staticClass:"peopleComponent-tb"},_vm._l((_vm.peopleComponentList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.returnIsCom(item.itemName)),expression:"returnIsCom(item.itemName)"}],key:index,class:['item', `${item.itemName}`]},[_c('div',{staticClass:"item-t"},[_c('p',[_vm._v(" "+_vm._s(item.itemValue)+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].unit ? _vm.hHDictionary[item.itemName].unit : "")+" ")]),_c('p',{staticClass:"returnIsComTxt"},[_vm._v(_vm._s(item.extra))])]),_c('div',{staticClass:"item-b"},[(_vm.returnIsCom(item.itemName) && item.itemName)?_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.returnIsCom(item.itemName)
                    ? require(`./img/${item.itemName}.png`)
                    : '',"alt":""}})]):_vm._e(),_c('div',{staticClass:"txt"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].value ? _vm.hHDictionary[item.itemName].value : "")+" ")])])])}),0)]),_c('div',{staticClass:"peopleComponent-c"},[_vm._v(_vm._s(_vm.peopleComponentData.advise))]),_c('div',{staticClass:"peopleComponent-b"},[_c('div',{staticClass:"title"},[_vm._v("体重组成")]),_c('div',{staticClass:"peopleComponent-box"},[_c('div',{staticClass:"Weight item"},[_vm._m(0),_c('div',{staticClass:"item-b"},[(_vm.peopleComponentData.FatWeight)?_c('div',{staticClass:"item-bt"},[_vm._v(" 脂肪"+_vm._s(_vm.peopleComponentData.FatWeight["itemValue"])+" "+_vm._s(_vm.peopleComponentData.FatWeight.itemName && _vm.hHDictionary[_vm.peopleComponentData.FatWeight.itemName].value ? _vm.hHDictionary[_vm.peopleComponentData.FatWeight.itemName].unit : "")+" ")]):_vm._e(),(_vm.peopleComponentData.NoFatWeight)?_c('div',{staticClass:"item-bb"},[_vm._v(" 去脂体重"+_vm._s(_vm.peopleComponentData.NoFatWeight.itemValue)+"kg ")]):_vm._e()])]),_c('div',{staticClass:"NoFat item"},[_vm._m(1),_c('div',{staticClass:"item-b"},[(_vm.peopleComponentData.BoneWeight)?_c('div',{staticClass:"item-bt"},[_vm._v(" 骨量"+_vm._s(_vm.peopleComponentData.BoneWeight["itemValue"])+" "+_vm._s(_vm.peopleComponentData.BoneWeight.itemName && _vm.hHDictionary[_vm.peopleComponentData.BoneWeight.itemName].value ? _vm.hHDictionary[_vm.peopleComponentData.BoneWeight.itemName].unit : "")+" ")]):_vm._e(),(_vm.peopleComponentData.MuscleMass)?_c('div',{staticClass:"item-bb"},[_vm._v(" 肌肉"+_vm._s(_vm.peopleComponentData.MuscleMass.itemValue)+"kg ")]):_vm._e()])]),_c('div',{staticClass:"MuscleMass item"},[_vm._m(2),_c('div',{staticClass:"item-b"},[(_vm.peopleComponentData.danbai)?_c('div',{staticClass:"item-bt"},[_vm._v(" 蛋白质"+_vm._s(_vm.peopleComponentData.danbai["itemValue"])+"kg ")]):_vm._e(),(_vm.peopleComponentData.BodyWater)?_c('div',{staticClass:"item-bb"},[_vm._v(" 水分"+_vm._s(_vm.peopleComponentData.BodyWater.itemValue)+"kg ")]):_vm._e()])])]),_c('div',{staticClass:"title"},[_vm._v("详细数据")]),_c('div',{staticClass:"peopleComponentList"},_vm._l((_vm.peopleComponentList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.itemName),expression:"item.itemName"}],key:index,staticClass:"item"},[(item.itemName)?_c('div',{staticClass:"item-t"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].value ? _vm.hHDictionary[item.itemName].value : "")+" ")]):_vm._e(),_c('div',{class:['item-c', 'oActive', item.class]},[_vm._v(" "+_vm._s(item.extra)+" ")]),(item.itemName)?_c('div',{staticClass:"item-b"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].formatter ? _vm.hHDictionary[item.itemName].formatter(item.itemValue) : item.itemValue)+_vm._s(item.itemName && _vm.hHDictionary[item.itemName] ? _vm.hHDictionary[item.itemName].unit : "")+" ")]):_vm._e()])}),0)])]):_vm._e(),(_vm.oKey == _vm.bloodPre.examItemCode)?_c('div',{staticClass:"healthReport-c"},[_c('div',{staticClass:"dongmai"},[_c('div',{staticClass:"title"},[_vm._v("动脉硬化评估")]),_c('div',{staticClass:"intro"},[_vm._v(" 动脉硬化是动脉的一种非炎症性病变，可使动脉管壁增厚、变硬，失去弹性、管腔狭窄。 定期检查对于脑中风、脑溢血、心肌梗塞、高血压等心脑血管疾病的防治具有重要意义。 ")]),_c('div',{staticClass:"title"},[_vm._v("中心动脉硬度指标（Avi）")]),_c('div',{staticClass:"intro"},[_vm._v(" AVI是指中心动脉硬化程度指标，是将最高血压以上的高袖套压脉波波形的特征加以数据化，数值越高表明动脉硬化的风险越高。 ")]),_c('div',{staticClass:"Avi"},[(_vm.bloodPreData.Avi)?_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Avi.itemValue,
                    0,
                    _vm.AviLevel[0],
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    '最小'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Avi.itemValue,
                    0,
                    _vm.AviLevel[0],
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Avi.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])]),_c('div',{staticClass:"item2 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.AviLevel[0]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[0],
                    _vm.AviLevel[1],
                    Number(_vm.AviLevel[2]) + 4,
                    0
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[0],
                    _vm.AviLevel[1],
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Avi.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("轻度")])]),_c('div',{staticClass:"item4 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.AviLevel[1]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[1],
                    _vm.AviLevel[2],
                    Number(_vm.AviLevel[2]) + 4,
                    0
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[1],
                    _vm.AviLevel[2],
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Avi.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("中度")])]),_c('div',{staticClass:"item5 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.AviLevel[2]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[2],
                    Number(_vm.AviLevel[2]) + 4,
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    '最大'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Avi.itemValue,
                    _vm.AviLevel[2],
                    Number(_vm.AviLevel[2]) + 4,
                    Number(_vm.AviLevel[2]) + 4,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Avi.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("重度")])])]):_vm._e()]),_c('div',{staticClass:"title"},[_vm._v("上臂动脉硬度指标（API）")]),_c('div',{staticClass:"intro"},[_vm._v(" API是指上臂动脉硬化程度指标，随着袖套的减压, 柔软的血管其动脉容积将急剧变化, 而硬的血管容积则缓慢地变化, 可将这个曲线的倾斜程度加以数据化，数值越高表明上臂动脉硬化程度风险越高。 ")]),_c('div',{staticClass:"Api"},[(_vm.bloodPreData.Api)?_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Api.itemValue,
                    0,
                    _vm.ApiLevel[0],
                    _vm.ApiLevel[2] + 6,
                    0,
                    '最小'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Api.itemValue,
                    0,
                    _vm.ApiLevel[0],
                    _vm.ApiLevel[2] + 6,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Api.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])]),_c('div',{staticClass:"item2 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.ApiLevel[0]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[0],
                    _vm.ApiLevel[1],
                    _vm.ApiLevel[2] + 6,
                    0
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[0],
                    _vm.ApiLevel[1],
                    _vm.ApiLevel[2] + 6,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Api.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("轻度")])]),_c('div',{staticClass:"item4 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.ApiLevel[1]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[1],
                    _vm.ApiLevel[2],
                    _vm.ApiLevel[2] + 6,
                    0
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[1],
                    _vm.ApiLevel[2],
                    _vm.ApiLevel[2] + 6,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Api.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("中度")])]),_c('div',{staticClass:"item5 item"},[_c('div',{staticClass:"num"},[_vm._v(_vm._s(_vm.ApiLevel[2]))]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[2],
                    _vm.ApiLevel[2] + 6,
                    _vm.ApiLevel[2] + 6,
                    0,
                    '最大'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Api.itemValue,
                    _vm.ApiLevel[2],
                    _vm.ApiLevel[2] + 6,
                    _vm.ApiLevel[2] + 6,
                    0,
                    164
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Api.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("重度")])])]):_vm._e()]),_c('div',{staticClass:"title"},[_vm._v("全部指标")]),(_vm.bloodPre.examResultList)?_c('div',{staticClass:"bloodPreList oTable"},_vm._l((_vm.bloodPre.examResultList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(item.itemName != 'Age'),expression:"item.itemName != 'Age'"}],key:index,staticClass:"item"},[_c('div',{staticClass:"item-l"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] ? _vm.hHDictionary[item.itemName].value : item.itemName)+" ")]),_c('div',{staticClass:"item-c"},[_vm._v(" "+_vm._s(item.itemValue ? item.itemValue : "--")+" ")]),_c('div',{staticClass:"item-r"},[(item.itemName == 'Avi')?_c('span',[_vm._v(" "+_vm._s(_vm.AviTxt)+" ")]):_vm._e(),(item.itemName == 'Api')?_c('span',[_vm._v(" "+_vm._s(_vm.ApiTxt)+" ")]):_vm._e(),(item.itemName != 'Avi' && item.itemName != 'Api')?_c('span',[_vm._v(" "+_vm._s(item.itemName && _vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].range ? _vm.hHDictionary[item.itemName].range : item.range))]):_vm._e()])])}),0):_vm._e(),_c('div',{staticClass:"title"},[_vm._v("检测建议")]),_c('div',{staticClass:"advise"},[_vm._v(_vm._s(_vm.bloodPreData.advise))]),_c('div',{staticClass:"title"},[_vm._v("血压")]),_c('div',{staticClass:"intro"},[_vm._v(" 血压指血液在血管内流动时作用于单位面积血管壁的侧压力，检查所测量的一般是体循环的动脉血压，包括收缩压与舒张压。 血压正常代表人体心脏和血管都处于正常运转状态。 ")]),_c('div',{staticClass:"thirdItem"},_vm._l((_vm.bloodPre.examResultList),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.returnIsbloodPre(item.itemName)),expression:"returnIsbloodPre(item.itemName)"}],key:index,staticClass:"item"},[_c('div',{staticClass:"item-t"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] ? _vm.hHDictionary[item.itemName].value : "")+" ")]),_c('div',{class:['item-b']},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].formatter ? _vm.hHDictionary[item.itemName].formatter(item.itemValue) : item.itemValue)+" "+_vm._s(item.itemName && _vm.hHDictionary[item.itemName] ? _vm.hHDictionary[item.itemName].unit : "")+" ")])])}),0),_c('div',{staticClass:"title"},[_vm._v("血压测量结果分布")]),_c('div',{staticClass:"High"},[(_vm.bloodPreData.High)?_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.High.itemValue,
                    0,
                    90,
                    210,
                    0,
                    '最小'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    0,
                    90,
                    210,
                    0,
                    1.6
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("偏低")])]),_c('div',{staticClass:"item2 item"},[_c('div',{staticClass:"num"},[_vm._v("90/60")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(_vm.bloodPreData.High.itemValue, 90, 130, 199, 0)
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    90,
                    130,
                    199,
                    0,
                    1.6
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])]),_c('div',{staticClass:"item3 item"},[_c('div',{staticClass:"num"},[_vm._v("130/85")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(_vm.bloodPreData.High.itemValue, 130, 139, 210, 0)
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    130,
                    139,
                    210,
                    0,
                    2
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常偏高")])]),_c('div',{staticClass:"item4 item"},[_c('div',{staticClass:"num"},[_vm._v("139/89")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(_vm.bloodPreData.High.itemValue, 139, 159, 199, 0)
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    139,
                    159,
                    199,
                    0,
                    1.6
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("轻度高血压")])]),_c('div',{staticClass:"item5 item"},[_c('div',{staticClass:"num"},[_vm._v("159/99")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.High.itemValue,
                    159,
                    179,
                    199,
                    0,
                    '最大'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    159,
                    179,
                    199,
                    0,
                    1.6
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("中度高血压")])]),_c('div',{staticClass:"item6 item"},[_c('div',{staticClass:"num"},[_vm._v("179/109")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.High.itemValue,
                    179,
                    199,
                    199,
                    0,
                    '最大'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.High.itemValue,
                    179,
                    199,
                    199,
                    0,
                    1.6
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.High.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("重度高血压")])])]):_vm._e()]),_c('div',{staticClass:"title"},[_vm._v("心率测量结果分布")]),_c('div',{staticClass:"Heart"},[_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Heart.itemValue,
                    0,
                    60,
                    140,
                    0,
                    '最小'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Heart.itemValue,
                    0,
                    60,
                    140,
                    0,
                    220
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Heart.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("偏低")])]),_c('div',{staticClass:"item3 item"},[_c('div',{staticClass:"num"},[_vm._v("60")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(_vm.bloodPreData.Heart.itemValue, 60, 100, 140, 0)
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Heart.itemValue,
                    60,
                    100,
                    140,
                    0,
                    220
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Heart.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])]),_c('div',{staticClass:"item5 item"},[_c('div',{staticClass:"num"},[_vm._v("100")]),_c('div',{staticClass:"item-t"},[(
                  _vm.returnCircle(
                    _vm.bloodPreData.Heart.itemValue,
                    100,
                    140,
                    140,
                    0,
                    '最大'
                  )
                )?_c('div',{staticClass:"circle",style:({
                  left: _vm.returnLeft(
                    _vm.bloodPreData.Heart.itemValue,
                    100,
                    140,
                    140,
                    0,
                    220
                  ),
                })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.bloodPreData.Heart.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("偏高")])])])]),_c('div',{staticClass:"title"},[_vm._v("血压等级判断标准")]),(_vm.bloodPre.examResultList)?_c('div',{staticClass:"bloodPreList oTable"},_vm._l((_vm.bloodPreGrade),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"item-l"},[_vm._v(" "+_vm._s(item.value)+" ")]),_c('div',{staticClass:"item-c"},[_vm._v(" "+_vm._s(item.High ? item.High : "--")+" ")]),_c('div',{staticClass:"item-r"},[_vm._v(" "+_vm._s(item.Low)+" ")])])}),0):_vm._e(),_c('div',{staticClass:"careInfo"},[_vm._v(" 注：判断标准参考《中国高血压防治指南2018年修订版》，当收缩压和舒张压分属于不同级别时，以较高的分级为主 ")]),_c('div',{staticClass:"title"},[_vm._v("检测建议")]),_c('div',{staticClass:"advise"},[_vm._v(_vm._s(_vm.bloodPreData.bloodAdvise))])])]):_vm._e(),(_vm.oKey == _vm.boneMD.examItemCode)?_c('div',{staticClass:"healthReport-c"},[_c('div',{staticClass:"boneMD"},[_c('div',{staticClass:"title"},[_vm._v("骨密度检测")]),_c('div',{staticClass:"sexAge"},[(_vm.reportListData.data)?_c('div',{staticClass:"sexAge-l"},[_vm._v(" 性别："+_vm._s(_vm.reportListData.data.gender == "M" ? "男" : "女")+" ")]):_vm._e(),_c('div',{staticClass:"sexAge-l"},[_vm._v("年龄："+_vm._s(_vm.reportListData.data.age))])]),_c('div',{staticClass:"time"},[_vm._v("*检测时间："+_vm._s(_vm.boneMD.createTime))]),_c('div',{staticClass:"intro"},[_vm._v(" 骨密度是指骨单位体积或者是单位面积所含的骨矿物量，它是反映骨骼强度的重要指标， 还是用来预测患者发生骨折可能性的重要依据。 ")]),_c('div',{staticClass:"title"},[_vm._v("T值")]),_c('div',{staticClass:"intro"},[_vm._v(" 骨质量与同性别20岁以上成人平均水平的比值，是骨密度评估的主要参数。 ")]),(_vm.boneMDData.Tscore)?_c('div',{staticClass:"targetItem"},[_c('div',{staticClass:"item1 item"},[_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.boneMDData.Tscore.itemValue,
                  -4,
                  -2.5,
                  4,
                  -4,
                  '最小'
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.boneMDData.Tscore.itemValue,
                  -4,
                  -2.5,
                  4,
                  -4,
                  220
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.boneMDData.Tscore.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("骨质疏松")])]),_c('div',{staticClass:"item3 item"},[_c('div',{staticClass:"num"},[_vm._v("-2.5")]),_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(_vm.boneMDData.Tscore.itemValue, -2.5, -1, 4, -4)
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.boneMDData.Tscore.itemValue,
                  -2.5,
                  -1,
                  4,
                  -4,
                  220
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.boneMDData.Tscore.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("骨量减少")])]),_c('div',{staticClass:"item5 item"},[_c('div',{staticClass:"num"},[_vm._v("-1.0")]),_c('div',{staticClass:"item-t"},[(
                _vm.returnCircle(
                  _vm.boneMDData.Tscore.itemValue,
                  -1,
                  4,
                  4,
                  -4,
                  '最大'
                )
              )?_c('div',{staticClass:"circle",style:({
                left: _vm.returnLeft(
                  _vm.boneMDData.Tscore.itemValue,
                  -1,
                  4,
                  4,
                  -4,
                  220
                ),
              })},[_c('div',{staticClass:"numItem"},[_vm._v(_vm._s(_vm.boneMDData.Tscore.itemValue))])]):_vm._e()]),_c('div',{staticClass:"item-b"},[_vm._v("正常")])])]):_vm._e(),_c('div',{staticClass:"title"},[_vm._v("骨密度等级判断标准")]),(_vm.boneMD.examResultList)?_c('div',{staticClass:"oTable"},_vm._l((_vm.boneMD.examResultList),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"item-l"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] ? _vm.hHDictionary[item.itemName].value : item.itemName)+" ")]),_c('div',{staticClass:"item-r"},[_vm._v(" "+_vm._s(_vm.hHDictionary[item.itemName] && _vm.hHDictionary[item.itemName].formatter ? _vm.hHDictionary[item.itemName].formatter(item.itemValue) : item.itemValue)+" ")])])}),0):_vm._e(),_c('div',{staticClass:"title"},[_vm._v("检测建议")]),_c('div',{staticClass:"advise"},[_vm._v(" "+_vm._s(_vm.boneMDData.advise)+" ")])])]):_vm._e(),_c('div',{staticClass:"healthReport-b"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-t"},[_c('div',{attrs:{"id":"Weight"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-t"},[_c('div',{attrs:{"id":"NoFat"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-t"},[_c('div',{attrs:{"id":"MuscleMass"}})])
}]

export { render, staticRenderFns }